@import '../../../../constants/spacing.module.less';

.modal-body-text {
  font-size: 14px;
  padding: @space-8 @space-0;
}
